// Web shim for @react-native-community/geolocation using browser API

const Geolocation = {
  getCurrentPosition(success, error, options) {
    if (!navigator.geolocation) {
      if (error) error({ code: 2, message: 'Geolocation not supported' });
      return;
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
  },

  watchPosition(success, error, options) {
    if (!navigator.geolocation) return -1;
    return navigator.geolocation.watchPosition(success, error, options);
  },

  clearWatch(watchId) {
    if (navigator.geolocation) {
      navigator.geolocation.clearWatch(watchId);
    }
  },

  setRNConfiguration() {},
  requestAuthorization() {},
};

export default Geolocation;
